/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import * as React from 'react'
import { StyledInputForSwitcher } from './styles'
type SwitcherInputProps = {
  id?: string
  disabled?: boolean
  name?: string
  checked?: boolean
  handleChange?: (...args: any[]) => any
}
export const SwitcherInput: React.SFC<SwitcherInputProps> = ({
  handleChange,
  id,
  disabled,
  name,
  checked,
}) => (
  <StyledInputForSwitcher
    type="checkbox"
    id={id}
    disabled={disabled}
    onChange={handleChange}
    name={name}
    checked={checked}
  />
)
